import Card from '../../../../components/Card/Card';
import './SessionCard.scss';
import {formatDate} from '../../../../utils/dateFormatter';

function SessionCard({dayNumber, sessions}) {

    return (
        <div className="session-card" key={`day-${dayNumber}`}>
          <div className="session-day">
            <label>Day {dayNumber}</label>
            <div className="vertical-line"></div>
          </div>
          <div className="sessions">
            {sessions &&
              sessions.map((session, index) => (
                <div key={`session-${session.id}`}>
                  <Card>
                    <div className="session-date">
                      <h2>Session {index + 1}</h2>
                      <label>START: {session.from} END: {session.to}</label>
                    </div>
                    <div className="session-attendance">
                      <label>{formatDate(session.date)}</label>
                      <button>Attendance</button>
                    </div>
                  </Card>
                </div>
              ))}
          </div>
        </div>
      );
}
export default SessionCard;